const servicesData = [
    {
      title: "Luxury Hand Wash",
      description: "High quality hand wash, foam bath, clean exterior windows, door jams cleaned, minor bug removal, wheel and tire dressing, and hand dry with ultra plush microfiber towels.",
      priceCar: "$45",
      priceTruck: "$65",
      priceSUV: "$65",
      priceVAN: "$65",
      duration: "30 min",
      image: require("../imgs/services/service1.jpg")
    },
    {
      title: "Complete Interior",
      description: "Express Interior, clean and shampoo the upholstery and carpets, door jams cleaned and console and glove box cleaning.",
      priceCar: "$150",
      priceTruck: "$175",
      priceSUV: "$200",
      priceVAN: "$200",
      duration: "1.5 hr",
      image: require("../imgs/services/service4.jpg")
    },
    {
      title: "Complete Basic Detail",
      description: "Hand wash, Express interior, Orbital high speed wax, door jams cleaned, dash, console and glove box cleaning.",
      priceCar: "$200",
      priceTruck: "$300",
      priceSUV: "$375",
      priceVAN: "$375",
      duration: "1.5 hr",
      image: require("../imgs/services/service4.jpg")
    },
    {
      title: "Ultimate Enhancement",
      description: "Complete basic detail, high speed buff and polish, hand wax, interior shampoo and basic engine cleaning.",
      priceCar: "$300",
      priceTruck: "$400",
      priceSUV: "$500",
      priceVAN: "$500",
      duration: "2 hr",
      image: require("../imgs/services/service4.jpg")
    }
  ];
  
  export default servicesData;